import MarketShare from "../../../src/visualization/connectedCharts/ConnectedMarketShare";
import { buildMeta } from "../../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Market Share — The Atlas of Economic Complexity",
      description:
        "See how a country's share of the global market for a product has changed over time.",
      ogImage: "share_market.png",
    },
    args,
  );
}

export default function MarketShareRoute() {
  return <MarketShare />;
}
